import type {HTMLAttributes} from 'react';

export function RobloxSignet(props: HTMLAttributes<SVGElement>) {
	return (
		<svg
			fill="none"
			height="150"
			viewBox="0 0 150 150"
			width="150"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M31.698 0 0 118.302 118.302 150 150 31.698 31.698 0Zm55.405 95.965-33.058-8.862 8.862-33.058 33.071 8.862-8.875 33.058Z"
				fill="currentColor"
			/>
		</svg>
	);
}
